import React from 'react';
import { Container, Grid, Typography, Box, IconButton, Link } from '@mui/material';
import {
    Phone,
    Email,
    LocationOn,
    Facebook
} from '@mui/icons-material';
import '../styles/Footer.scss';
import { Link as RouterLink } from 'react-router-dom';

const legalLinks = [
    { title: 'Adatkezelés', path: '/adatkezeles' },
    { title: 'Impresszum', path: '/impresszum' },
    { title: 'GYIK', path: '/gyik' },
    { title: 'ÁSZF', path: '/aszf' }
];

const Footer = () => {
    return (
        <footer className="footer">
            <Container>
                <Grid container spacing={3} alignItems="center">
                    <Grid item xs={12} md={4}>
                        <Box className="contact-item">
                            <Phone className="icon" />
                            <Typography>
                                <a href="tel:+36706185311">+36 70 618 5311</a>
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Box className="contact-item">
                            <Email className="icon" />
                            <Typography>
                                <a href="mailto:iroda@toronyszerver.hu">iroda@toronyszerver.hu</a>
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Box className="contact-item">
                            <LocationOn className="icon" />
                            <Typography>
                                2230 Gyömrő, Állomás utca 15.
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>

                <Box className="copyright">
                    <Box className="footer-links">
                        <Typography>
                            © {new Date().getFullYear()} Toronyszerver KFT
                        </Typography>
                        <Box className="divider">|</Box>
                        <Box className="legal-links">
                            {legalLinks.map((link, index) => (
                                <React.Fragment key={link.path}>
                                    <Link
                                        component={RouterLink}
                                        to={link.path}
                                        color="inherit"
                                        sx={{
                                            textDecoration: 'none',
                                            '&:hover': {
                                                textDecoration: 'underline'
                                            }
                                        }}
                                    >
                                        {link.title}
                                    </Link>
                                    {index < legalLinks.length - 1 && (
                                        <Typography component="span" sx={{ mx: 1 }}>•</Typography>
                                    )}
                                </React.Fragment>
                            ))}
                        </Box>
                        <Box className="divider">|</Box>
                        <IconButton
                            href="https://facebook.com/toronyszerver"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="social-button"
                            size="small"
                        >
                            <Facebook />
                        </IconButton>
                    </Box>
                </Box>
            </Container>
        </footer>
    );
};

export default Footer; 